<template>
  <div class="header">
    <v-card
      class="py-0 py-md-2 header-card"
      color="white"
      min-height="65"
      tile
      flat
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="d-flex align-center">
              <div class="d-flex align-center">
                <v-dialog v-model="drawer" width="500">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="drawer = !drawer"
                      class="mt-n1 hidden-lg-and-up"
                      icon
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-img
                        alt="Bars"
                        class="bars"
                        src="@/assets/img/public/shared/header/bars.svg"
                        max-width="24"
                        contain
                      />
                    </v-btn>
                  </template>

                  <v-card
                    class="nav-bar d-flex flex-column"
                    color="white"
                    width="254"
                    tile
                    flat
                  >
                    <!-- Top -->
                    <div>
                      <!-- Close -->
                      <v-card
                        @click="drawer = !drawer"
                        class="pa-4"
                        color="gray200"
                        width="100%"
                        height="48"
                        tile
                        flat
                      >
                        <div
                          class="d-flex justify-start align-center gray200 mt-n1"
                        >
                          <v-icon color="gray600" class="mr-2">close</v-icon>

                          <p
                            class="b-body-1 font-weight-medium ma-0 pa-0 gray800--text"
                          >
                            Close
                          </p>
                        </div>
                      </v-card>

                      <!-- My loan and Personal data-->
                      <v-list v-if="auth.loggedIn" width="100%" flat>
                        <!-- My loan -->
                        <v-list-item
                          @click="drawer = !drawer"
                          :to="{ name: 'DashboardMyLoanPage' }"
                          exact-active-class="bg-active"
                        >
                          <v-icon>$walletIcon</v-icon>

                          <h6 class="h6 ml-1">My loan</h6>
                        </v-list-item>

                        <!-- Personal data -->
                        <v-list-item
                          @click="drawer = !drawer"
                          :to="{ name: 'DashboardPersonalDataPage' }"
                          exact-active-class="bg-active"
                        >
                          <v-icon>$briefcaseIcon</v-icon>
                          <h6 class="h6 ml-1">Personal data</h6>
                        </v-list-item>
                      </v-list>

                      <!-- Need Help -->
                      <!-- <v-card
                        @click="setNeedHelp()"
                        class="pa-4 mt-n2"
                        color="white"
                        width="100%"
                        height="48"
                        tile
                        flat
                      >
                        <div class="d-flex justify-start align-center mt-n1">
                          <div class="d-flex justify-space-around mr-2">
                            <v-img
                              alt="envelope-r"
                              class="envelope-r"
                              src="@/assets/img/public/shared/header/envelope-r.svg"
                              contain
                              max-width="24"
                            />
                          </div>

                          <h6 class="h6 ma-0 pa-0 primary--text">Need help</h6>
                        </div>
                      </v-card> -->

                      <!-- divider -->
                      <v-img
                        alt="divider"
                        class="divider"
                        src="@/assets/img/public/shared/header/divider.svg"
                      />

                      <!-- About Lime and FAQs and Blog-->
                      <v-list class="mt-n2" width="100%" flat>
                        <!-- About Lime -->
                        <v-list-item
                          @click="drawer = !drawer"
                          :to="{ name: 'AboutLimePage' }"
                          exact-active-class="bg-active"
                        >
                          <h6 class="h6 ml-1">About Us</h6>
                        </v-list-item>

                        <!-- FAQs -->
                        <v-list-item
                          @click="drawer = !drawer"
                          :to="{ name: 'FAQsPage' }"
                          exact-active-class="bg-active"
                        >
                          <h6 class="h6 ml-1">FAQs</h6>
                        </v-list-item>
                        <div
                          class="text-decoration-none b-subtitle-1 py-1 px-4 pointer"
                          @click="openReferFriendDialog"
                        >
                          Refer Friend
                        </div>
                      </v-list>
                    </div>

                    <v-spacer />

                    <!-- Bottom -->
                    <div v-if="auth.loggedIn">
                      <v-list width="100%" flat>
                        <!-- Username -->
                        <v-list-item exact-active-class="bg-active">
                          <v-icon>$userLIcon</v-icon>

                          <h6 class="b-body-1 ml-1">
                            {{
                              $helpers.formatTheHeaderUserFullname(
                                "sidebar",
                                `${auth.user.firstnames} ${auth.user.surname}`,
                              )
                            }}
                          </h6>
                        </v-list-item>
                      </v-list>

                      <!-- Exit -->
                      <div class="px-4 py-3">
                        <div @click="logOut()" class="custom-btn">
                          <div class="d-flex align-center">
                            <v-img
                              alt="sign-out-alt-s"
                              class="sign-out-alt-s"
                              src="@/assets/img/public/shared/header/sign-out-alt-s.svg"
                              max-width="24"
                              contain
                            />

                            <h6 class="b-btn-text primary--text ml-2 mt-n1">
                              Exit
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                </v-dialog>

                <router-link :to="{ name: 'HomePage' }">
                  <v-img
                    alt="Logo"
                    class="logo"
                    src="@/assets/img/public/shared/logos/logo2.png"
                    contain
                    max-width="150"
                  />
                </router-link>
                <!-- <router-link :to="{ name: 'HomePage' }">
                  <v-img
                    alt="Logo"
                    class="logo"
                    src="@/assets/img/public/shared/logos/logo.svg"
                    contain
                    max-width="100"
                  />
                </router-link> -->
              </div>

              <v-spacer></v-spacer>

              <div class="hidden-sm-and-down">
                <div class="d-flex">
                  <!-- About Lime -->
                  <router-link
                    class="text-decoration-none b-subtitle-1 py-1 px-4"
                    active-class="active"
                    :to="{ name: 'AboutLimePage' }"
                  >
                    About Us
                  </router-link>

                  <!-- FAQs -->
                  <router-link
                    class="text-decoration-none b-subtitle-1 ml-2 py-1 px-4"
                    active-class="active"
                    :to="{ name: 'FAQsPage' }"
                  >
                    FAQs
                  </router-link>

                  <!-- Refer Friend -->
                  <div
                    class="text-decoration-none b-subtitle-1 ml-2 py-1 px-4 pointer"
                    @click="openReferFriendDialog"
                  >
                    Refer Friend
                  </div>
                </div>
              </div>
              <v-spacer></v-spacer>

              <div class="d-flex align-center">
                <!-- Phone -->
                <div class="hidden-sm-and-down">
                  <div class="d-flex">
                    <a
                      href="tel:+27210541057"
                      class="text-decoration-none"
                      target="_blank"
                    >
                      <div class="d-flex align-center">
                        <!-- <v-img alt="Phone" class="phone" src="@/assets/img/public/shared/header/phone.svg"
                          max-width="18" contain /> -->
                        <v-icon color="#08338F">mdi-phone</v-icon>

                        <h6 class="b-subtitle-1 ml-2 primary--text">
                          +27 21 054 1057
                        </h6>
                      </div>
                    </a>
                  </div>
                </div>

                <!--  -->
                <div v-if="auth.loggedIn" class="d-flex align-center ml-md-10">
                  <router-link
                    :to="{ name: 'DashboardMyLoanPage' }"
                    class="text-decoration-none"
                  >
                    <h6 class="b-body-1 text-capitalize">
                      <!-- small -->
                      <div class="small-mobile">
                        {{
                          $helpers.formatTheHeaderUserFullname(
                            "small",
                            `${auth.user.firstnames} ${auth.user.surname}`,
                          )
                        }}
                      </div>

                      <!-- medium -->
                      <div class="medium-mobile">
                        {{
                          $helpers.formatTheHeaderUserFullname(
                            "medium",
                            `${auth.user.firstnames} ${auth.user.surname}`,
                          )
                        }}
                      </div>

                      <!-- large -->
                      <div class="large-mobile">
                        {{
                          $helpers.formatTheHeaderUserFullname(
                            "large",
                            `${auth.user.firstnames} ${auth.user.surname}`,
                          )
                        }}
                      </div>

                      <!-- other -->
                      <div class="other">
                        {{
                          $helpers.formatTheHeaderUserFullname(
                            "other",
                            `${auth.user.firstnames} ${auth.user.surname}`,
                          )
                        }}
                      </div>
                    </h6>
                  </router-link>

                  <v-img
                    alt="Sign Out Alt"
                    class="sign-out-alt mx-2"
                    src="@/assets/img/public/shared/header/vertical-divider.svg"
                    max-width="1"
                    contain
                  />

                  <!-- Log out -->
                  <v-btn @click="logOut()" icon>
                    <!-- <v-img alt="Sign Out Alt" class="sign-out-alt"
                      src="@/assets/img/public/shared/header/sign-out-alt.svg" max-width="24" contain /> -->
                    <v-icon>mdi-logout</v-icon>
                  </v-btn>
                </div>

                <!-- Login Button -->
                <div v-else>
                  <div class="hidden-sm-and-down">
                    <div
                      :to="{ name: 'LoginPage' }"
                      class="login-btn ml-10 pointer"
                      @click="loginButton()"
                    >
                      <div class="d-flex align-center">
                        <!-- <v-img alt="Sign In Alt" class="sign-in-alt"
                          src="@/assets/img/public/shared/header/sign-in-alt.svg" max-width="24" contain /> -->
                        <v-icon color="#08338F">mdi-login</v-icon>

                        <h6 class="b-button ml-2 primary--text">Log In</h6>
                      </div>
                    </div>
                  </div>

                  <router-link
                    :to="{ name: 'LoginPage' }"
                    class="text-decoration-none hidden-md-and-up"
                  >
                    <div class="d-flex align-center">
                      <!-- <v-img alt="Sign In Alt" class="sign-in-alt"
                      src="@/assets/img/public/shared/header/sign-in-alt.svg" max-width="24" contain /> -->
                      <v-icon color="#08338F">mdi-login</v-icon>

                      <h6 class="b-subtitle-1 ml-2 mr-2 primary--text">
                        Log In
                      </h6>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </v-col>

          <!-- Need help -->
          <v-dialog v-model="dialog" width="500">
            <v-img
              alt="live-agent"
              class="live-agent.png"
              src="@/assets/img/dashboard/pages/sidebar/live-agent.png"
              contain
              width="502"
            />
          </v-dialog>

          <!-- Refer Friend Dialog -->
          <v-dialog
            v-model="referFriendDialog"
            max-width="700"
            transition="dialog-transition"
          >
            <v-card class="refer-friend-card" elevation="24">
              <v-card-title class="refer-friend-header">
                <div class="d-flex justify-end align-center w-100 pa-2">
                  <v-btn
                    icon
                    @click="closeReferFriendDialog"
                    color="grey"
                    class="close-btn ml-auto"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-card-title>

              <v-card-text class="pa-0">
                <!-- Non-logged-in user view -->
                <div v-if="!auth.loggedIn" class="px-3 pb-1">
                  <!-- Hero Section -->
                  <div class="text-center">
                    <h4 class="text-h5 font-weight-bold primary--text mb-2">
                      Invite Friends, Earn Big!
                    </h4>
                    <div class="reward-badge mx-auto mb-2">
                      <v-chip
                        color="success"
                        text-color="white"
                        class="px-6 py-2"
                      >
                        <!-- <v-icon left>mdi-cash-multiple</v-icon> -->
                        <span class="font-weight-bold"
                          >R200 per succesful referral</span
                        >
                      </v-chip>
                    </div>
                  </div>

                  <!-- How it Works Section -->
                  <div class="mb-6">
                    <h3
                      class="text-h8 font-weight-bold primary--text mb-2 text-center"
                    >
                      <v-icon color="primary" class="mr-2"
                        >mdi-lightbulb-on</v-icon
                      >
                      How It Works
                    </h3>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        v-for="(step, index) in howItWorksSteps"
                        :key="index"
                      >
                        <v-card
                          class="step-card pa-4 text-center"
                          elevation="2"
                          hover
                        >
                          <!-- <v-avatar size="60" :color="step.color" class="mb-3">
                            <v-icon color="white" size="30">{{
                              step.icon
                            }}</v-icon>
                          </v-avatar> -->
                          <h4 class="font-weight-bold mb-2">
                            {{ step.title }}
                          </h4>
                          <p class="grey--text text--darken-1 mb-0">
                            {{ step.description }}
                          </p>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- Benefits Section -->
                  <div class="mb-5">
                    <h3
                      class="text-h5 font-weight-bold primary--text text-center"
                    >
                      Terms and Conditions
                    </h3>
                    <v-row>
                      <v-col
                        cols="12"
                        md="4"
                        v-for="(benefit, index) in benefits"
                        :key="index"
                      >
                        <div class="benefit-item d-flex align-start mb-n5">
                          <div>
                            <ul
                              class="grey--text text--darken-1 mb-0 caption pl-4"
                            >
                              <li
                                v-for="(desc, i) in benefit.description"
                                :key="i"
                              >
                                {{ desc }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>

                  <!-- CTA Section -->
                  <div class="text-center">
                    <v-btn
                      color="primary"
                      rounded
                      elevation="4"
                      @click="handleStartEarning()"
                      class="px-8 py-2 cta-button"
                    >
                      <v-icon left>mdi-login</v-icon>
                      Start Earning
                    </v-btn>
                    <p class="caption grey--text mt-3 mb-0">
                      For any queries or enquiries, email
                      refer-a-friend@centuryfinancialservices.net
                    </p>
                  </div>
                </div>

                <!-- Logged-in user view -->
                <div v-else class="pa-6 pt-0">
                  <!-- Header Section -->
                  <div class="text-center mb-6">
                    <v-avatar size="64" color="success" class="mb-3">
                      <v-icon color="white" size="32">mdi-account-check</v-icon>
                    </v-avatar>
                    <h1 class="text-h4 font-weight-bold primary--text mb-2">
                      Generate Your Referral Link
                    </h1>
                    <p class="text-subtitle-1 grey--text text--darken-1">
                      Complete your details to create a personalized referral
                      link
                    </p>
                  </div>

                  <!-- Form Section -->
                  <v-card class="form-card pa-6 mb-6" elevation="2" outlined>
                    <v-form ref="referralForm" v-model="formValid">
                      <!-- Generated URL Display -->
                      <div class="mt-4 mb-4">
                        <v-text-field
                          :value="generatedUrl"
                          label="Your Referral Link"
                          outlined
                          readonly
                          dense
                          prepend-inner-icon="mdi-link"
                          append-icon="mdi-content-copy"
                          @click:append="copyGeneratedUrl"
                          hide-details
                        ></v-text-field>
                      </div>
                      <div class="text-center mt-4">
                        <v-btn
                          color="primary"
                          rounded
                          :loading="generatingLink"
                          @click="generateReferralLink"
                          class="px-8 generate-btn"
                        >
                          <v-icon left>mdi-link-variant</v-icon>
                          Generate My Referral Link
                        </v-btn>
                      </div>
                    </v-form>
                  </v-card>

                  <!-- Referral Link Section -->
                  <v-expand-transition>
                    <div v-if="referralLink">
                      <v-card
                        class="success-card pa-6"
                        elevation="4"
                        color="success lighten-5"
                      >
                        <div class="text-center mb-4">
                          <v-avatar size="48" color="success" class="mb-2">
                            <v-icon color="white">mdi-check-circle</v-icon>
                          </v-avatar>
                          <h3
                            class="text-h5 font-weight-bold success--text mb-2"
                          >
                            Link Generated Successfully!
                          </h3>
                          <p class="grey--text text--darken-1">
                            Your personalized referral link is ready to share
                          </p>
                        </div>

                        <v-text-field
                          :value="referralLink"
                          label="Your Referral Link"
                          outlined
                          readonly
                          dense
                          prepend-inner-icon="mdi-link"
                          append-icon="mdi-content-copy"
                          @click:append="copyReferralLink"
                          class="referral-link-field mb-4"
                          background-color="white"
                        ></v-text-field>

                        <!-- Share Options -->
                        <div class="text-center">
                          <p
                            class="text-subtitle-2 grey--text text--darken-1 mb-3"
                          >
                            Share via:
                          </p>
                          <v-btn-toggle
                            v-model="shareMethod"
                            mandatory
                            class="share-buttons"
                          >
                            <v-btn value="whatsapp" color="success" outlined>
                              <v-icon left>mdi-whatsapp</v-icon>
                              WhatsApp
                            </v-btn>
                            <v-btn value="sms" color="primary" outlined>
                              <v-icon left>mdi-message-text</v-icon>
                              SMS
                            </v-btn>
                            <v-btn value="email" color="info" outlined>
                              <v-icon left>mdi-email</v-icon>
                              Email
                            </v-btn>
                          </v-btn-toggle>
                        </div>

                        <v-alert
                          type="info"
                          outlined
                          dense
                          class="mt-4 mb-0"
                          icon="mdi-information"
                        >
                          <small
                            >Share this link with friends to earn R200 for each
                            successful loan referral!</small
                          >
                        </v-alert>
                      </v-card>
                    </div>
                  </v-expand-transition>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  name: "LimeLoansTheHeader",

  data() {
    return {
      clientId: 0,
      drawer: false,
      group: null,

      dialog: false,
      fullName: "",

      // Refer Friend Dialog
      referFriendDialog: false,
      generatingLink: false,
      shareMethod: "whatsapp",
      referralForm: {
        firstnames: "",
        surname: "",
        idnumber: "",
        cellular: "",
      },
      referralLink: "",

      // Generated URL properties
      formValid: false,
      generatedUrl: "",
      responseData: {
        clientId: null,
        firstName: "",
        lastName: "",
        idNumber: "",
        phoneNumber: "",
        createdAt: "",
      },

      howItWorksSteps: [
        {
          icon: "mdi-login",
          title: "Join Program",
          description:
            "Log in, click on refer a friend and complete the form to receive your unique Referral Link",
          color: "primary",
        },
        {
          icon: "mdi-share-variant",
          title: "Share Link",
          description: "Share your link via social media, SMS, or email.",
          color: "info",
        },
        {
          icon: "mdi-cash-multiple",
          title: "Earn Rewards",
          description:
            "Get R200 for every approved and disbursed loan you referred",
          color: "success",
        },
      ],
      benefits: [
        {
          icon: "mdi-currency-usd",
          title: "",
          description: [
            "You must have a valid South African bank account in your own name registered on your Century FS profile.",
          ],
          color: "success",
        },
        {
          icon: "mdi-trending-down",
          title: "",
          description: [
            "Referral commission will only be paid on a new client’s approved and disbursed first loan.",
          ],
          color: "primary",
        },
        {
          icon: "mdi-shield-check",
          title: "",
          description: [
            "Referral commission will be paid to the first referrer who registered the referred person, if multiple referrers submit the same referral.",
            " Commissions will be paid out on Mondays for the previous week’s referred disbursed loans.",
          ],
          color: "info",
        },
      ],
      rules: {
        required: (value) => !!value || "This field is required",
        firstNames: (value) => {
          if (!value) return "First name is required";
          if (!/^[a-zA-Z\s]+$/.test(value))
            return "First name must contain only letters and spaces";
          if (value.length < 2)
            return "First name must be at least 2 characters";
          if (value.length > 50)
            return "First name cannot exceed 50 characters";
          return true;
        },
        surname: (value) => {
          if (!value) return "Surname is required";
          if (!/^[a-zA-Z\s]+$/.test(value))
            return "Surname must contain only letters and spaces";
          if (value.length < 2) return "Surname must be at least 2 characters";
          if (value.length > 50) return "Surname cannot exceed 50 characters";
          return true;
        },
        idNumber: (value) => {
          if (!value) return "ID Number is required";
          if (value.length !== 13) return "ID Number must be 13 digits";
          if (!/^\d+$/.test(value))
            return "ID Number must contain only numbers";
          return true;
        },
        cellular: (value) => {
          if (!value) return "Cell phone number is required";
          if (!/^0\d{9}$/.test(value))
            return "Cell phone number must be 10 digits starting with 0";
          return true;
        },
      },
    };
  },

  created() {
    this.clientId = this.getClientId;
  },

  computed: {
    ...mapState({ auth: "auth" }),

    ...mapGetters({
      getClientId: "auth/getClientId",
    }),
  },

  mounted() {},

  methods: {
    ...mapActions({
      logOutUser: "auth/logOutUser",
    }),

    ...mapMutations({
      resetState: "auth/resetState",
    }),

    // Login Button
    loginButton() {
      this.$router.push({
        name: "LoginPage",
      });
    },

    // logOut
    logOut() {
      this.logOutUser();
      // this.$router.push("/");
    },

    // setNeedHelp
    setNeedHelp() {
      this.dialog = true;

      this.drawer = false;
    },

    // Open Refer Friend Dialog
    openReferFriendDialog() {
      this.referFriendDialog = true;
      this.drawer = false;
    },

    // Close Refer Friend Dialog
    closeReferFriendDialog() {
      this.referFriendDialog = false;
      this.referralLink = "";
      this.resetReferralForm();
    },

    // Reset Referral Form
    resetReferralForm() {
      this.referralForm = {
        firstnames: "",
        surname: "",
        idnumber: "",
        cellular: "",
      };
      if (this.$refs.referralForm) {
        this.$refs.referralForm.resetValidation();
      }
    },

    // Copy Referral Link
    copyReferralLink() {
      if (this.referralLink) {
        navigator.clipboard
          .writeText(this.referralLink)
          .then(() => {
            this.$toast.success("Referral link copied to clipboard!");
          })
          .catch(() => {
            // Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = this.referralLink;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);
            this.$toast.success("Referral link copied to clipboard!");
          });
      }
    },

    // Copy Generated URL
    copyGeneratedUrl() {
      if (this.generatedUrl) {
        navigator.clipboard
          .writeText(this.generatedUrl)
          .then(() => {
            this.$toast.success("Referral link copied to clipboard!");
          })
          .catch(() => {
            // Fallback for older browsers
            const textArea = document.createElement("textarea");
            textArea.value = this.generatedUrl;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("copy");
            document.body.removeChild(textArea);
            this.$toast.success("Referral link copied to clipboard!");
          });
      }
    },

    // Handle Start Earning button - login and close dialog
    handleStartEarning() {
      this.loginButton();
      // Close dialog after a short delay to allow login process
      setTimeout(() => {
        this.closeReferFriendDialog();
      }, 500);
    },

    async generateReferralLink() {
      this.overlay = true;

      try {
        this.generatingLink = true;

        this.generatedUrl = `https://trk.centuryza.co.za/click?pid=341&offer_id=3&sub1=${this.clientId}`;
      } catch (error) {
        this.$toast.error("Referral generation failed.");
      } finally {
        this.overlay = false;
        this.generatingLink = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  .header-card {
    box-shadow: 0px 0px 8px rgba(61, 61, 61, 0.12),
      0px 2px 4px rgba(61, 61, 61, 0.06);
  }

  .logo {
    width: 100%;
    width: 180px;
    height: auto;
  }

  .active {
    background: #f5f5f5;
    border-radius: 16px;

    color: #3d3d3d;
  }

  @media only screen and (max-width: 768px) {
    .header-card {
      height: 52px;

      .logo {
        width: 120px;
        margin-bottom: 5px;
      }
    }
  }

  @media (max-width: 480px) {
    .logo {
      width: 100px;
    }
  }
}

.navigation-drawer {
  z-index: 9999999;
}

.custom-btn {
  border: 1px solid #08338f;
  border-radius: 4px;

  height: 48px;
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0px 32px 0px 24px;
  gap: 8px;
}

.nav-bar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}

.h6 {
  //styleName: 16 M/semibold;
  font-family: "Noto Sans Display";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.01em;
}

.bg-active {
  background-color: white;
  color: #08338f !important;
  // box-shadow: 0px 0px 8px rgba(61, 61, 61, 0.12),
  //   0px 2px 4px rgba(61, 61, 61, 0.06);
  border-radius: 8px;
}

.login-btn {
  /* Button */
  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 142px;
  height: 48px;

  /* Primary Lime/500 */
  border: 1px solid #08338f;
  border-radius: 4px;
}

@media only screen and (max-width: 320px) {
  .small-mobile {
    display: block;
  }

  .medium-mobile {
    display: none;
  }

  .large-mobile {
    display: none;
  }

  .other {
    display: none;
  }
}

@media (min-width: 321px) and (max-width: 375px) {
  .small-mobile {
    display: none;
  }

  .medium-mobile {
    display: block;
  }

  .large-mobile {
    display: none;
  }

  .other {
    display: none;
  }
}

@media (min-width: 376px) and (max-width: 425px) {
  .small-mobile {
    display: none;
  }

  .medium-mobile {
    display: none;
  }

  .large-mobile {
    display: block;
  }

  .other {
    display: none;
  }
}

@media (min-width: 426px) {
  .small-mobile {
    display: none;
  }

  .medium-mobile {
    display: none;
  }

  .large-mobile {
    display: none;
  }

  .other {
    display: block;
  }
}

/* Refer Friend Dialog Styles */
.refer-friend-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.refer-friend-header {
  .header-gradient {
    background: linear-gradient(135deg, #4caf50 0%, #2e7d32 50%, #1b5e20 100%);
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
      pointer-events: none;
    }
  }

  .close-btn {
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.2) !important;
      transform: rotate(90deg);
    }
  }
}

.step-card {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  &:hover {
    transform: translateY(-4px);
    border-color: #4caf50;
    box-shadow: 0 8px 25px rgba(76, 175, 80, 0.2) !important;
  }
}

.benefit-item {
  transition: all 0.3s ease;
  padding: 8px;
  border-radius: 8px;

  &:hover {
    background: rgba(76, 175, 80, 0.05);
    transform: translateX(4px);
  }
}

.cta-button {
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(76, 175, 80, 0.3) !important;
  }
}

.form-card {
  border-radius: 12px !important;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;

  &:hover {
    border-color: #4caf50;
    box-shadow: 0 4px 20px rgba(76, 175, 80, 0.1) !important;
  }
}

.modern-input {
  .v-input__control {
    .v-input__slot {
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 2px 8px rgba(76, 175, 80, 0.1);
      }
    }
  }
}

.generate-btn {
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(76, 175, 80, 0.3) !important;
  }
}

.success-card {
  border-radius: 12px !important;
  border: 2px solid #4caf50;
  animation: slideInUp 0.5s ease-out;
}

.referral-link-field {
  .v-input__control {
    .v-input__slot {
      background: white !important;
      border: 2px solid #4caf50 !important;
      border-radius: 8px !important;
    }
  }
}

.share-buttons {
  .v-btn {
    margin: 0 4px;
    border-radius: 20px !important;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
    }
  }
}

.reward-badge {
  animation: pulse 2s infinite;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.dialog-transition-enter-active,
.dialog-transition-leave-active {
  transition: all 0.3s ease;
}

.dialog-transition-enter,
.dialog-transition-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
</style>
